module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUBAMAAAANaGKIAAAAG1BMVEUAAAAjHwAwiipMliSciQCuvBD21wD32QD52gC0aMGzAAAATklEQVR42m3OQQ2AQBADwIo4BXhAwGnABBJQACeb12WyyfY5SdNmfddRcj4r91b2ZmxlM6GMMsqKMspCWShrsK/3Q6y/ScMoo6woo2H0B1vIVJuzfRdZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/jm.png
// module id = 852
// module chunks = 0